import React from 'react';
import AuthButton from './AuthButton';

// Older call sites use PrimaryButton; it draws the same button as the auth
// screens so every full-width action in the app looks identical.
// variant: 'primary' | 'secondary' (white, outlined) | 'danger'
const VARIANTS = {primary: 'primary', secondary: 'light', danger: 'danger'};

const PrimaryButton = ({variant = 'primary', ...props}) => (
  <AuthButton variant={VARIANTS[variant] ?? 'primary'} {...props} />
);

export default PrimaryButton;
